/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Subtitle_LabelInputs */

const en_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle`)
};

const fr_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitle`)
};

const de_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Untertitel`)
};

const it_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sottotitolo`)
};

const ru_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры`)
};

const es_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Subtitular`)
};

const zh_cn2_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const ja_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕`)
};

const hi_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपशीर्षक`)
};

const pt_pt2_file_import_subtitle_label = /** @type {(inputs: File_Import_Subtitle_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Legenda`)
};

/**
* | output |
* | --- |
* | "Subtitle" |
*
* @param {File_Import_Subtitle_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_subtitle_label = /** @type {((inputs?: File_Import_Subtitle_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Subtitle_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_subtitle_label(inputs)
	if (locale === "de") return de_file_import_subtitle_label(inputs)
	if (locale === "it") return it_file_import_subtitle_label(inputs)
	if (locale === "ru") return ru_file_import_subtitle_label(inputs)
	if (locale === "es") return es_file_import_subtitle_label(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_subtitle_label(inputs)
	if (locale === "ja") return ja_file_import_subtitle_label(inputs)
	if (locale === "hi") return hi_file_import_subtitle_label(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_subtitle_label(inputs)
	return en_file_import_subtitle_label(inputs)
});